module.exports = __webpack_public_path__ + "img/ga.d9a3e7fd.svg";